var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dashboard-container"},[_c('h1',{staticClass:"dashboard-title"},[_vm._v(_vm._s(_vm.business.name))]),_c('div',{staticClass:"dashboard-card"})])}
var staticRenderFns = []

export { render, staticRenderFns }